import { useState } from 'react';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import { priceFormatSuperscript } from '@/lib/price';
import { priceFormater } from '@/settings/index';
import PricingBoxComparePrice from './PricingBoxComparePrice';
import BeforeTradeIn from './BeforeTradeIn';
import ReviewsSummary from './ReviewsSummary';
import PrimaryTitleWithBadge from './PrimaryTitleWithBadge';
import { splitProductTitle } from './helpers';
import ReviewsModal from '../../../secondary/reviews/ReviewsModal';

export default function PricingBoxHeader() {
  const {
    selectedSkuDetails: { title, compareAtPrice, finalPrice },
    additionalInfo: { reviews },
  } = useProductPageContext();
  const { primaryTitle, secondaryTitle, showUnlocked } =
    splitProductTitle(title);
  const hasReviews = Boolean(reviews?.summary);
  const hasComparePrice = Boolean(
    compareAtPrice && compareAtPrice > 0 && finalPrice < compareAtPrice,
  );
  const [showReviewsModal, setShowReviewsModal] = useState(false);

  return (
    <div className="hidden grid-cols-[minmax(0,1fr)_auto] gap-x-4 gap-y-0 lg:grid">
      <div className="min-w-0">
        {/* Not an <h1>: this copy is only hidden with CSS below `lg`, so it is
            in the HTML on every viewport alongside the mobile title, which is
            the page's one <h1>. The heading role keeps a level-1 heading for
            assistive tech on desktop, where the mobile copy is display:none. */}
        <div
          role="heading"
          aria-level={1}
          className="relative min-w-0 text-xl font-bold leading-none text-gray-700"
          id="e2e-pdp-title"
        >
          <PrimaryTitleWithBadge
            primaryTitle={primaryTitle}
            showUnlocked={showUnlocked}
          />
        </div>
        {secondaryTitle && (
          <div className="mt-1 text-sm font-medium leading-tight text-gray-700">
            {secondaryTitle}
          </div>
        )}
        {hasReviews && (
          <div className="mt-3">
            <ReviewsSummary
              summary={reviews?.summary}
              onClick={() => setShowReviewsModal(true)}
            />
          </div>
        )}
      </div>
      <div className="flex flex-col items-end self-start justify-self-end text-right">
        {finalPrice > 0 && (
          <div className="flex items-baseline gap-2">
            <BeforeTradeIn />
            <div className="text-[20px] font-bold leading-none" translate="no">
              {priceFormatSuperscript(priceFormater.long(finalPrice))}
            </div>
          </div>
        )}
        {hasComparePrice && (
          <PricingBoxComparePrice align="right" className="mt-2" />
        )}
      </div>
      <ReviewsModal
        showModal={showReviewsModal}
        setShowModal={setShowReviewsModal}
      />
    </div>
  );
}
